import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileText = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-file-text-icon lucide-file-text",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 9H8" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 13H8" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 17H8" })
	]
});
export default SvgFileText;
